export default function Divider(theme) {
    return {
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor:theme.palette.divider,
                    borderBottomWidth: '1px',
                    marginTop: '12px',
                    marginBottom: '12px',
                    opacity: 1, 
                },
                vertical: {
                    height: '100%',
                    margin: '0 8px',
                    borderRightWidth: '1px',
                    alignSelf: 'stretch',
                },
                wrapper: {
                    paddingLeft: '0px',
                    color: '#616161',
                    fontSize: '12px',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                }
            }
        }
    };
}